import React from 'react'
import { FormControl, Select, MenuItem, Typography, Box, SelectChangeEvent } from '@mui/material'
import { ADOPTION_STATUS_OPTIONS } from '../types'

interface AdoptionStatusFieldProps {
  value: string
  onChange: (value: string) => void
  label?: string
}

const labelStyle = {
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '0.75rem',
  mb: 0.5,
  display: 'block',
}

const AdoptionStatusField: React.FC<AdoptionStatusFieldProps> = ({
  value,
  onChange,
  label = 'Platform Adoption',
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value)
  }

  return (
    <Box>
      <Typography component="label" sx={labelStyle}>
        {label}
      </Typography>
      <FormControl fullWidth size="small">
        <Select displayEmpty value={value} onChange={handleChange}>
          {ADOPTION_STATUS_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default AdoptionStatusField
